module.exports = __webpack_public_path__ + "europa-5-emerald_number.jpg?e531319dde066444fe8eecfdb507a4b2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-5-emerald_number.jpg
// module id = 345
// module chunks = 0